import { useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

import useModalDialog from "../../hooks/useModalDialog";

const overlay = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.05, delayChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.25, ease: [0.16, 1, 0.3, 1] } },
};

export default function MobileNav({ isOpen, setIsOpen, links }) {
  const close = useCallback(() => setIsOpen(false), [setIsOpen]);
  const containerRef = useModalDialog(isOpen, close);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.nav
          ref={containerRef}
          tabIndex={-1}
          aria-label="Mobile menu"
          id="mobile-menu"
          variants={overlay}
          initial="hidden"
          animate="show"
          exit="hidden"
          className="fixed inset-0 z-40 flex flex-col justify-center gap-6 bg-paper px-6 outline-none sm:hidden"
        >
          {links.map((l) => (
            <motion.a
              key={l.href}
              href={l.href}
              onClick={close}
              variants={item}
              className="font-reactor text-4xl font-bold [font-variation-settings:'wdth'_5] transition-colors duration-200 hover:text-primary"
            >
              {l.label.replace(/^\d+\s/, "")}
            </motion.a>
          ))}
          <motion.button
            type="button"
            onClick={close}
            variants={item}
            className="mt-6 self-start font-mono text-[11px] uppercase tracking-[0.16em] text-muted transition-colors duration-200 hover:text-primary"
          >
            Close ✕
          </motion.button>
        </motion.nav>
      )}
    </AnimatePresence>
  );
}
